import { render } from "./StudentSubmissionDialog.vue?vue&type=template&id=7ad0d1c4&scoped=true"
import script from "./StudentSubmissionDialog.vue?vue&type=script&lang=js"
export * from "./StudentSubmissionDialog.vue?vue&type=script&lang=js"

import "./StudentSubmissionDialog.vue?vue&type=style&index=0&id=7ad0d1c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad0d1c4"]])

export default __exports__